import { LOCALES, LOCALE_STORAGE_KEY } from "./constants";

import type { SupportedLocale } from "./types";

export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
  return value ? (LOCALES as readonly string[]).includes(value) : false;
}

export function readStoredLocale(): SupportedLocale | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const storedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return isSupportedLocale(storedLocale) ? storedLocale : null;
  } catch (error) {
    console.warn("Failed to read stored locale:", error);
    return null;
  }
}

export function saveStoredLocale(locale: SupportedLocale) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (error) {
    console.warn("Failed to save locale:", error);
  }
}

/** Limpa o storage sem perder o idioma escolhido na barra (evita Accept-Language só do navegar após `clear()`). */
export function clearLocalStoragePreservingLocale() {
  if (typeof window === "undefined") {
    return;
  }

  let saved: string | null = null;
  try {
    saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  } catch {
    // ignore
  }

  try {
    window.localStorage.clear();
    if (saved && isSupportedLocale(saved)) {
      window.localStorage.setItem(LOCALE_STORAGE_KEY, saved);
    }
  } catch (error) {
    console.warn("Failed to clear localStorage:", error);
  }
}
